// extracted by mini-css-extract-plugin
export default {"seatUsageWidth":"100px"};